/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ShareSkillRequestBody,
  ShareSkillRequestBody$Outbound,
  ShareSkillRequestBody$outboundSchema,
} from "../components/shareskillrequestbody.js";

export type ShareSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ShareSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ShareSkillSecurity = {
  option1?: ShareSkillSecurityOption1 | undefined;
  option2?: ShareSkillSecurityOption2 | undefined;
};

export type ShareSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  shareSkillRequestBody: ShareSkillRequestBody;
};

/** @internal */
export type ShareSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ShareSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  ShareSkillSecurityOption1$Outbound,
  ShareSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function shareSkillSecurityOption1ToJSON(
  shareSkillSecurityOption1: ShareSkillSecurityOption1,
): string {
  return JSON.stringify(
    ShareSkillSecurityOption1$outboundSchema.parse(shareSkillSecurityOption1),
  );
}

/** @internal */
export type ShareSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ShareSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  ShareSkillSecurityOption2$Outbound,
  ShareSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function shareSkillSecurityOption2ToJSON(
  shareSkillSecurityOption2: ShareSkillSecurityOption2,
): string {
  return JSON.stringify(
    ShareSkillSecurityOption2$outboundSchema.parse(shareSkillSecurityOption2),
  );
}

/** @internal */
export type ShareSkillSecurity$Outbound = {
  Option1?: ShareSkillSecurityOption1$Outbound | undefined;
  Option2?: ShareSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ShareSkillSecurity$outboundSchema: z.ZodMiniType<
  ShareSkillSecurity$Outbound,
  ShareSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => ShareSkillSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => ShareSkillSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function shareSkillSecurityToJSON(
  shareSkillSecurity: ShareSkillSecurity,
): string {
  return JSON.stringify(
    ShareSkillSecurity$outboundSchema.parse(shareSkillSecurity),
  );
}

/** @internal */
export type ShareSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ShareSkillRequestBody: ShareSkillRequestBody$Outbound;
};

/** @internal */
export const ShareSkillRequest$outboundSchema: z.ZodMiniType<
  ShareSkillRequest$Outbound,
  ShareSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    shareSkillRequestBody: ShareSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      shareSkillRequestBody: "ShareSkillRequestBody",
    });
  }),
);

export function shareSkillRequestToJSON(
  shareSkillRequest: ShareSkillRequest,
): string {
  return JSON.stringify(
    ShareSkillRequest$outboundSchema.parse(shareSkillRequest),
  );
}
